module.exports = __webpack_public_path__ + "static/media/MVNZ_web_5.73ca44f4.jpg";